/* The disc behind every record's cover - Rue's card design, 28 Sep 2026.
   Generated by Storefront Artwork/artwork/sleeve.py - do not edit by hand.

   A record picture is an <img> inside a link to /products/<handle>. Where the
   visitor has a mouse, the disc that belongs to that pressing (window.PN_DISCS)
   is put behind the cover, and pn-sleeve.css slides it out on hover. Pictures
   added later (Catalog "more", genre strips) are caught as they arrive. */
(function () {
  var D = window.PN_DISCS || {}, P = D.p || '', R = D.r || {}, SZ = D.s || {}, BK = D.b || {}, BJ = D.j || {};
  /* the product page's back face shows the record's other side where its label is known */
  function isBack(img) {
    return img.classList.contains('pnah-face--back') || !!(img.closest && img.closest('.pnsn-face--back'));
  }
  /* a verified 7-inch record: its disc, label and spindle hole drawn to 7-inch
     proportions ("7s" small hole, "7l" large hole); never assumed */
  function seven(h) { return h && SZ[h] ? ' pn-disc--7 pn-disc--' + String(SZ[h]).split(':')[0] : ''; }
  /* a large hole as photographed in this record's own label (share of the label radius) */
  function holeVar(h, labelShare) {
    var lh = h && SZ[h] ? +String(SZ[h]).split(':')[1] : 0;
    return lh ? '--pn-hole:' + (lh * labelShare * 100).toFixed(2) + '%;' : '';
  }
  var HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var SEL = 'img.pn-record-cover, .card .img img, .pnh-card .img img, .pnh-rec img, img[data-pn-handle]';

  function handleOf(el) {
    /* the product page's front sleeve names its record directly */
    if (el.getAttribute && el.getAttribute('data-pn-handle')) return el.getAttribute('data-pn-handle');
    var a = el.closest ? el.closest('a[href*="/products/"]') : null;
    if (!a) return '';
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  function url(f, w) {
    if (!f) return '';
    var u = /^https?:/.test(f) ? f : P + f;
    return u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=' + w;
  }
  /* the After Hours page turns two faces in 3D: the wrapper of each face has to carry the turn */
  function face(img) {
    return img.classList.contains('pnah-face--back') ? ' pn-sleeve--back'
      : img.classList.contains('pnah-face--front') ? ' pn-sleeve--front' : '';
  }
  function dress(img) {
    if (img.hasAttribute('data-pn-sleeve')) return;
    img.setAttribute('data-pn-sleeve', '1');
    var host = img.parentNode;
    if (!host) return;
    var h = handleOf(img);
    /* the product page's back face: the record's own back cover where one is known (6 Oct).
       Asked before the disc test, so a record shown as its bare disc turns to its sleeve's back as well (11 Oct) */
    var bj = !img.hasAttribute('data-pn-passport-art') && h && isBack(img) && BJ[h] ? BJ[h] : '';
    if (bj) {
      /* a sleeve picture behind a bare disc is dressed as a sleeve; a picture disc's other side stays a disc */
      if (/-disc\.png/.test(img.getAttribute('src') || '') && !/-disc\.png/.test(bj)) { img.classList.add('pn-sleeve-main'); host.classList.add('pn-disc-host'); }
      img.src = url(bj, 900);
    }
    if (/-disc\.png/.test(img.getAttribute('src') || '')) {      /* a coloured record shows its disc */
      img.classList.add('pn-disc-main');
      host.classList.add('pn-disc-host');
      return;
    }
    var kv = h && Object.prototype.hasOwnProperty.call(R, h) ? R[h] : null;
    if (/-box3d[a-z0-9]*\.webp/.test(img.getAttribute('src') || '')) {  /* a box set: the 3D box, nothing behind it */
      img.classList.add('pn-box-main');
      host.classList.add('pn-box-host');
      return;
    }
    /* die-cut sleeves: -sleeve-c.png, and rebuilt ones with a version (-sleeve-cs30.png ...) */
    if (!bj && kv && kv[6] === 'k' && /-sleeve(-c[a-z0-9]*)?\.png/.test(img.getAttribute('src') || '')) {
      /* the 3D die-cut sleeve: the record is always inside (the hole shows its
         label, on every device); a mouse slides it out */
      var r = +kv[5], sz = 94, lab = kv[1] || '';
      if (isBack(img) && BK[h]) {          /* the other side: its label, and its sleeve where that differs */
        if (typeof BK[h] === 'string') lab = BK[h];
        else { lab = BK[h][0]; if (BK[h][1]) img.src = url(BK[h][1], 900); }
      }
      var sl = document.createElement('span');
      sl.className = 'pn-sleeve pn-sleeve--3d' + face(img);
      var d3 = document.createElement('span');
      d3.className = 'pn-disc pn-disc--vinyl' + (kv[2] ? ' pn-disc--colour' : '') + seven(h);
      d3.setAttribute('aria-hidden', 'true');
      var st = 'left:' + ((+kv[3]) * 100 - sz / 2).toFixed(2) + '%;top:' + ((+kv[4]) * 100 - sz / 2).toFixed(2) + '%;width:' + sz + '%;height:' + sz + '%;';
      if (kv[2]) st += kv[2] + ';'; else if (D.v) st += "background-image:url('" + url(D.v, 900) + "');";
      st += holeVar(h, 2 * r / (sz / 100));
      d3.setAttribute('style', st);
      if (lab) {
        var li = document.createElement('img');
        li.setAttribute('data-pn-sleeve', '1');
        li.alt = ''; li.loading = 'lazy'; li.draggable = false;
        li.className = 'pn-disc-label pn-disc-label--3d';
        var lw = (2 * r / (sz / 100)) * 100;
        li.setAttribute('style', 'width:' + lw.toFixed(2) + '%!important;height:' + lw.toFixed(2) + '%!important;left:' + (50 - lw / 2).toFixed(2) + '%!important;top:' + (50 - lw / 2).toFixed(2) + '%!important');
        li.src = url(lab, 500);
        d3.appendChild(li);
      }
      /* the record is INSIDE the sleeve: clipped to the sleeve's top, bottom
         and closed spine, so it only ever shows through the hole or out of
         the open right-hand side */
      var clip = document.createElement('span');
      clip.className = 'pn-disc-clip';
      clip.appendChild(d3);
      host.insertBefore(sl, img);
      sl.appendChild(clip);
      sl.appendChild(img);
      img.classList.add('pn-sleeve-main');
      host.classList.add('pn-sleeve-host', 'pn-disc-host');
      return;
    }
    if (!HOVER) return;
    if (!h || !Object.prototype.hasOwnProperty.call(R, h)) return;
    var v = R[h] || ['', '', ''], disc = v[0] || '', label = v[1] || '', css = v[2] || '';
    var sleeve = document.createElement('span');
    sleeve.className = 'pn-sleeve' + face(img);
    var d = document.createElement('span');
    d.className = 'pn-disc' + (disc ? ' pn-disc--photo' : (label ? ' pn-disc--label' : '')) + seven(h);
    d.setAttribute('aria-hidden', 'true');
    if (css || holeVar(h, 0.51)) d.setAttribute('style', (css ? css + ';' : '') + holeVar(h, 0.51));
    if (disc || label) {
      var i = document.createElement('img');
      i.setAttribute('data-pn-sleeve', '1');
      i.alt = ''; i.loading = 'lazy'; i.draggable = false;
      i.className = disc ? 'pn-disc-photo' : 'pn-disc-label';
      i.src = disc ? url(disc, 600) : url(label, 300);
      d.appendChild(i);
    }
    host.insertBefore(sleeve, img);
    sleeve.appendChild(d);
    sleeve.appendChild(img);
    host.classList.add('pn-sleeve-host');
  }
  function scan(root) {
    var l = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < l.length; i++) dress(l[i]);
  }
  scan();
  if (window.MutationObserver) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var added = ms[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SEL)) dress(n);
          if (n.querySelectorAll) scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* More than two pictures of a record, in place - Rue, 11 Oct 2026: "no need to have a window pop up to show the
   images, the images must just change as you click on the image on the product page ... as someone keeps clicking
   on the record image". For a record in PN_DISCS.g (file names beside PN_DISCS.p: its sleeve's covers, a picture
   disc's other side) the page's own turn does the showing: just before each turn the face that is turned away is
   given the next picture, so every click turns to a new one and, after the last, back to the first. Nothing opens,
   nothing is added to the page, and the listing's own photos are not part of it. */
(function () {
  /* NOTO's own photographs (Rue, 1 Oct: every photo from the label's page, each cut out of its backdrop) used to
     open in a pop-up. Rue, 11 Oct: "change Noto also to just regular like all the others, you click on image and
     it changes" - so they turn in place as well, and the pop-up is gone. The listing's own photos are not part of it. */
  var G = {"noto":["https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-cover-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-box1696-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-box1699-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-box1700-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-ab-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-cd-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-ef-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-gh-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-ij-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-kl-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-mn-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-op-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-qr-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-st-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-uv-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-wx-g1.webp?v=1790891021"],"noto-12x10-ltd-rp-col-box-mint-m":["https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-cover-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-box1696-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-box1699-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-box1700-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-ab-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-cd-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-ef-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-gh-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-ij-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-kl-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-mn-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-op-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-qr-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-st-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-uv-g1.webp?v=1790891021","https://cdn.shopify.com/s/files/1/0679/7737/9977/files/pn-art-noto-gal-wx-g1.webp?v=1790891021"]};
  var D = window.PN_DISCS || {}, X = {}, P = D.p || '', k;
  for (k in G) if (Object.prototype.hasOwnProperty.call(G, k)) X[k] = G[k];
  for (k in (D.g || {})) if (Object.prototype.hasOwnProperty.call(D.g, k)) X[k] = D.g[k];
  if (!document.addEventListener) return;
  function sized(u, w) {
    u = (/^https?:/.test(u) ? u : P + u).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=' + w;
  }
  function find(t) {
    var host = t && t.closest ? t.closest('.pnsn-flip, .pnah-sleeve') : null;
    var front = host ? host.querySelector('img.pn-pdp-art[data-pn-handle]') : null;
    var h = front ? front.getAttribute('data-pn-handle') : '';
    if (!h || !Object.prototype.hasOwnProperty.call(X, h) || !X[h].length) return null;
    var back = host.querySelector('.pnsn-face--back img, img.pnah-face--back');
    return back ? { host: host, front: front, back: back, h: h } : null;
  }
  function turnedOver(host) {
    if (host.classList.contains('pnah-sleeve')) return Math.round((+host.getAttribute('data-rot') || 0) / 180) % 2 === 1;
    var root = host.closest('.pnsn');
    return !!(root && root.classList.contains('is-flipped'));
  }
  function put(img, u) {
    var disc = /-disc\.png/.test(u), box = /-box3d[a-z0-9]*\.webp/.test(u);
    img.classList.toggle('pn-disc-main', disc);
    img.classList.toggle('pn-box-main', box);
    img.classList.toggle('pn-sleeve-main', !disc && !box);
    img.src = sized(u, 900);
  }
  function next(f) {
    var s = f.host.pnPics;
    if (!s) {
      s = f.host.pnPics = { list: [f.front.getAttribute('src')].concat(X[f.h]), at: 0 };
      s.list.forEach(function (u) { var p = new Image(); p.src = sized(u, 900); });
    }
    s.at = (s.at + 1) % s.list.length;
    put(turnedOver(f.host) ? f.front : f.back, s.list[s.at]);
  }
  /* capture, and the event is left alone: the page's own click / key handler turns the sleeve right after */
  document.addEventListener('click', function (e) { var f = find(e.target); if (f) next(f); }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var f = e.target && e.target.closest && e.target.closest('.pnah-sleeve') ? find(e.target) : null;
    if (f) next(f);
  }, true);
})();
/* A record with no genuine picture of its back does not turn (13 Oct 2026). PN_DISCS.n[handle] = 1: the click (or
   Enter / Space) on that record's sleeve is stopped before the page's own turn handler, so its front is never shown
   again as if it were a back. Per handle; every other record turns exactly as before. */
(function () {
  var N = (window.PN_DISCS || {}).n || {};
  if (!document.addEventListener) return;
  function host(t) {
    var s = t && t.closest ? t.closest('.pnsn-flip, .pnah-sleeve') : null;
    var f = s ? s.querySelector('img.pn-pdp-art[data-pn-handle]') : null;
    return f && Object.prototype.hasOwnProperty.call(N, f.getAttribute('data-pn-handle')) ? s : null;
  }
  function stop(e) { e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  document.addEventListener('click', function (e) { if (host(e.target)) stop(e); }, true);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && host(e.target)) { e.preventDefault(); stop(e); }
  }, true);
  function mark() {
    var a = document.querySelectorAll('img.pn-pdp-art[data-pn-handle]'), i, s;
    for (i = 0; i < a.length; i++) { s = host(a[i]); if (s) s.classList.add('pn-noback'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
})();
